import { __extends } from "tslib";
import { ApiClientBase } from './ApiClientBase';
import { Globals } from '../Misc';
import { NeoTypes } from '../AppServices';
var ReadApiClient = /** @class */ (function (_super) {
    __extends(ReadApiClient, _super);
    function ReadApiClient(apiPath, axios) {
        if (axios === void 0) { axios = Globals.appService.get(NeoTypes.Axios); }
        var _this = _super.call(this, apiPath, axios) || this;
        _this.get = _this.get.bind(_this);
        _this.getById = _this.getById.bind(_this);
        return _this;
    }
    /** Gets a list of entities */
    ReadApiClient.prototype.get = function () {
        return this.axios.get(this.apiPath);
    };
    /** Gets a single entity using the provided id. */
    ReadApiClient.prototype.getById = function (id) {
        return this.axios.get("".concat(this.apiPath, "/").concat(id));
    };
    return ReadApiClient;
}(ApiClientBase));
export { ReadApiClient };
